var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.initialFile)?_c('img',{ref:"img",attrs:{"src":this.initialFile.picture ? this.initialFile.picture.url : ''}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }